import React from "react";
import { GeneralTranslation, LocaleSuggestionOverlayTranslation, type TranslatedValue } from "@swo/storefront";
import { SwarovskiOptikLocaleFrontend, SwarovskiPageDataFrontend } from "@swo/storefront";

import { LocaleSuggestionOverlay } from "../components/LocaleSuggestionOverlay/LocaleSuggestionOverlay";
import { ReactTFC } from "../utils/fp/missing-ts-parts";
import { t2 } from "../domain/translations/translations";
import { HeaderT } from "../components/HeaderComponent/HeaderT";

export const LocaleSuggestionOverlayFromPageData: ReactTFC<{
  data: SwarovskiPageDataFrontend["dataOrError"];
  generalTranslations: GeneralTranslation & { otherCountriesLabel: TranslatedValue };
  localeSuggestionsTranslations: LocaleSuggestionOverlayTranslation;
  locale: SwarovskiOptikLocaleFrontend;
}> = props => {
  if (props.data._tag !== "Right" && props.data._tag !== "Both") {
    return null;
  }

  const {
    header: { translations: ht, languagePicker },
  } = props.data.right;

  const t: HeaderT = t2({ ...ht.languagePicker, ...ht.general, ...ht.header, ...ht.search });

  return (
    <LocaleSuggestionOverlay
      languagePicker={{ t, languagePicker: languagePicker }}
      locale={props.locale}
      localeSuggestionsTranslations={props.localeSuggestionsTranslations}
    />
  );
};
